import { createPermissionStore, IPermissionStore } from './permission-store';
import { createAuthorizer, IAuthorizer } from './authorizer';
import { PermissionKey } from '../types';

export interface ICreateAuthorizationContextOptions<TKey extends PermissionKey> {
    onPermissionsChange?: (args: { values: TKey[] }) => void;
}

export interface IAuthorizationContext<TKey extends PermissionKey> {
    permissionStore: IPermissionStore<TKey>;
    authorizer: IAuthorizer<TKey>;
}

export function createAuthorizationContext<TKey extends PermissionKey>(options: ICreateAuthorizationContextOptions<TKey> = {}): IAuthorizationContext<TKey> {
    const permissionStore = createPermissionStore<TKey>({ onChange: options.onPermissionsChange });
    const authorizer = createAuthorizer(permissionStore);
    return { permissionStore, authorizer };
}
